export const paymentAccounts = {
  // Stripe et Wompi sont DEUX intégrations, pas deux options d'une
  // seule : chacune a son écran et son en-tête. `tagline` est la ligne
  // qui situe (où elle encaisse et avec quels moyens de paiement).
  header: {
    stripe: {
      title: "Encaissements avec Stripe",
      tagline: "Cartes internationales · Espagne et la plupart des pays",
      description:
        "Connectez un ou plusieurs comptes Stripe et choisissez celui qui encaisse pour chaque annonce.",
    },
    wompi: {
      title: "Encaissements avec Wompi",
      tagline: "Colombie · PSE, Nequi et cartes colombiennes",
      description:
        "Connectez un ou plusieurs comptes Wompi et choisissez celui qui encaisse pour chaque annonce.",
    },
    bold: {
      title: "Paiements avec Bold",
      tagline: "Colombie et Pérou · PSE, Nequi, Bancolombia et cartes",
      description:
        "Connecte un ou plusieurs comptes Bold et choisis avec lequel chaque annonce encaisse.",
    },
    redsys: {
      title: "Paiements avec Redsys",
      tagline: "Espagne · Le TPE virtuel de votre banque",
      description:
        "Connectez le TPE virtuel de votre banque et choisissez avec quel compte chaque annonce encaisse. L'argent arrive directement sur votre compte bancaire.",
      card: "TPE virtuel de votre banque (Espagne)",
    },
  },

  // Wompi là où il ne s'applique pas. La passerelle dépend du pays de
  // l'ANNONCE, pas de celui du propriétaire : on parle donc de
  // logements, pas de vous.
  notAvailable: {
    title: "Wompi est fait pour les logements en Colombie",
    text: "Wompi encaisse en pesos colombiens via PSE, Nequi et les cartes colombiennes. Vous n'avez aucun logement là-bas : il n'y a donc rien à connecter ici.",
    hint: "Si vous publiez un logement en Colombie, cet écran s'ouvrira tout seul.",
    button: "Aller à {provider}",
  },

  session: {
    title: "Votre session a expiré",
    text: "Rien n'est perdu : vos comptes d'encaissement sont toujours connectés. Reconnectez-vous pour les voir.",
    button: "Se reconnecter",
  },

  status: {
    ready: "Prêt",
    incomplete: "Incomplet",
    unverified: "Non vérifié",
  },

  environment: {
    test: "Test",
  },

  accounts: {
    card: {
      title: "Vos comptes {provider}",
      subtitle: "Connectez de nouveaux comptes et vérifiez s'ils sont prêts à encaisser.",
    },
    searchPlaceholder: "Rechercher un compte par nom…",
    newButton: "Connecter un compte {provider}",
    noName: "Sans nom",
    fallbackName: "Compte n° {id}",
    defaultBadge: "Principal",
    listingsCount: "{count} annonce | {count} annonces",
    empty: {
      none: "Vous n'avez encore connecté aucun compte {provider}.",
      noMatch: "Aucun compte ne correspond à la recherche.",
    },
    actions: {
      edit: "Modifier",
      setDefault: "Définir comme principal",
      isDefault: "C'est déjà le principal",
      resume: "Terminer l'inscription",
      verify: "Vérifier",
      disconnect: "Déconnecter",
    },
  },

  assign: {
    card: {
      title: "Répartition par annonce",
      subtitle: "Choisissez les annonces qu'encaisse chaque compte {provider}.",
    },
    searchPlaceholder: "Rechercher une annonce par nom…",
    filter: {
      all: "Toutes",
      unassigned: "Non attribuées",
      notReady: "Sans encaissement",
      other: "Encaisse via {provider}",
    },
    // Aucun compte attribué. Quand on sait quel est le compte principal, on le
    // nomme : c'est ce que l'hôte veut savoir, sur quel compte encaisse l'annonce.
    autoOption: "Compte principal",
    autoOptionNamed: "Compte principal · {name}",
    autoOptionOther: "Compte principal {provider} · {name}",
    otherProvider: "Encaisse via {provider} · {name}",
    otherProviderLink: "Gérer dans {provider}",
    notReadyRow: "N'encaisse pas",
    notReadyRowTip: "Le compte attribué à cette annonce n'est pas encore prêt, le voyageur ne pourra donc pas payer.",
    notReadyAutoRow: "Votre compte principal n'encaisse pas",
    notReadyAutoRowTip: "Cette annonce utilise le compte principal, qui n'est pas encore prêt. Terminez-le ou attribuez-lui un autre compte.",
    notReadyBanner: "{count} annonce ne peut pas encaisser pour l'instant : son compte n'est pas encore prêt. Les voyageurs ne pourront pas la payer tant que vous n'aurez pas terminé ce compte. | {count} annonces ne peuvent pas encaisser pour l'instant : leur compte n'est pas encore prêt. Les voyageurs ne pourront pas les payer tant que vous n'aurez pas terminé ce compte.",
    notReadyBannerLink: "Voir ces annonces",
    defaultSuffix: " (principal)",
    empty: {
      none: "Vous n'avez pas encore d'annonces.",
      noMatch: "Aucune annonce ne correspond au filtre.",
    },
    count: "{shown} annonces affichées sur {total}",
  },

  drawer: {
    newTitle: "Connecter un compte {provider}",
    editTitle: "Modifier le compte {provider}",
    subtitle: "Donnez-lui un nom et choisissez les annonces qu'il encaisse.",
    closeAria: "Fermer le panneau",

    stripe: {
      title: "Inscription sur Stripe",
      subtitle: "Stripe vous demandera vos informations puis vous ramènera ici.",
      explain:
        "Nous vous emmenons sur Stripe pour créer le compte sous ce nom et vérifier vos informations. À votre retour, vous pourrez choisir les annonces qu'il encaisse ; si vous laissez l'inscription en chemin, le compte vous attend ici.",
      button: "Continuer sur Stripe",
      connecting: "Ouverture de Stripe…",
      resumeTitle: "Inscription Stripe inachevée",
      resumeSubtitle: "La vérification sur Stripe reste à terminer.",
      resumeExplain: "Ce compte a été créé mais n'a jamais terminé son inscription sur Stripe, il ne peut donc pas encore encaisser. Reprenez là où vous en étiez.",
      resumeButton: "Terminer l'inscription",
    },

    data: {
      title: "Informations du compte",
      subtitle: "Le nom n'est que pour vous : il vous aide à les distinguer.",
      label: "Nom du compte",
      labelPlaceholder: "Par exemple : Appartements de la plage",
      labelHint: "Le voyageur ne le voit jamais.",
      publicKey: "Clé publique",
      privateKey: "Clé privée",
      privateKeyKept: "Celle que vous aviez est conservée",
      privateKeyHint: "Laissez vide pour garder la clé enregistrée.",
      stripeId: "Identifiant Stripe",
    },

    listings: {
      title: "Annonces encaissées",
      subtitle: "Celles que vous cochez n'encaisseront plus sur leur compte précédent.",
      label: "Annonces de ce compte",
      selectedCount: "{selected} sur {total} cochées",
      searchPlaceholder: "Rechercher une annonce…",
      selectAll: "Tout sélectionner",
      clear: "Effacer",
      takenBy: "actuellement sur {name}",
      noResults: "Aucune annonce ne correspond à la recherche.",
      hint: "Les annonces que vous ne cochez sur aucun compte encaissent sur le principal.",
      otherHidden: "{count} annonce qui encaisse via {provider} n'apparaît pas ici : elle se gère sur son propre écran. | {count} annonces qui encaissent via {provider} n'apparaissent pas ici : elles se gèrent sur leur propre écran.",
    },

    footer: {
      isDefault: "C'est déjà le principal",
      setDefault: "Définir comme principal",
      disconnect: "Déconnecter",
      cancel: "Annuler",
      save: "Enregistrer",
      saving: "Enregistrement…",
    },
  },

  disconnect: {
    title: "Déconnecter le compte",
    subtitle: "Vous cesserez d'encaisser avec lui.",
    confirm:
      "Vous allez déconnecter « {name} ». Les réservations déjà encaissées ne changent pas, mais ce compte n'acceptera plus de nouveaux paiements.",
    blocked:
      "« {name} » encaisse encore {count} annonce. Il faut la basculer sur un autre compte avant de le déconnecter. | « {name} » encaisse encore {count} annonces. Il faut les basculer sur un autre compte avant de le déconnecter.",
    moveLabel: "Basculer ces annonces vers",
    moveHint: "Nous les basculons sur le compte choisi, puis nous déconnectons celui-ci.",
    cancel: "Annuler",
    accept: "Déconnecter",
    seeListings: "Voir ces annonces",
    moveAndDisconnect: "Basculer et déconnecter",
  },

  loading: {
    accounts: "Chargement de vos comptes d'encaissement…",
  },

  msg: {
    loadError: "Nous n'avons pas pu charger vos comptes d'encaissement.",
    labelRequired: "Donnez un nom au compte.",
    publicKeyRequired: "La clé publique Wompi manque.",
    privateKeyRequired: "La clé privée Wompi manque.",
    saved: "Compte enregistré.",
    saveError: "Nous n'avons pas pu enregistrer le compte.",
    stripeNoUrl: "Stripe ne nous a pas renvoyé le lien d'inscription. Réessayez.",
    stripeConnectError: "Nous n'avons pas pu ouvrir l'inscription Stripe.",
    verified: "Le compte est vérifié.",
    verifiedWithName: "Compte vérifié : {name}.",
    notVerified: "Le compte n'est pas encore vérifié. Vérifiez les clés.",
    verifyError: "Nous n'avons pas pu vérifier le compte.",
    defaultUpdated: "C'est maintenant le compte principal.",
    defaultError: "Nous n'avons pas pu changer le compte principal.",
    disconnected: "Compte déconnecté.",
    disconnectError: "Nous n'avons pas pu déconnecter le compte.",
    movedAndDisconnected: "Annonces basculées et compte déconnecté.",
    savedNotReady: "Attention : ce compte ne peut pas encore encaisser et {count} annonce lui est attribuée. Terminez-le, sinon cette annonce restera sans encaissement. | Attention : ce compte ne peut pas encore encaisser et {count} annonces lui sont attribuées. Terminez-le, sinon ces annonces resteront sans encaissement.",
    assignError: "Nous n'avons pas pu changer le compte de cette annonce.",
  },

  integrations: {
    connectedAccounts: "{count} compte connecté | {count} comptes connectés",
    notApplicable: "Pour les logements en Colombie",
    notApplicableSpain: "Pour les hébergements en Espagne",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Environnement",
    environmentHint: "Votre banque vous donne des identifiants de test et d'autres pour les vrais paiements. Choisissez à quoi correspondent ceux que vous saisissez.",
    env: {
      test: "Test",
      prod: "Réel",
    },
    merchantCode: "Numéro de commerçant (FUC)",
    merchantCodeHint: "Il figure dans votre contrat de TPE ou dans le module d'administration de Redsys. Uniquement des chiffres, généralement neuf.",
    terminal: "Terminal",
    terminalHint: "Presque toujours 1. Si votre banque vous en a donné plusieurs, celui du TPE virtuel.",
    secretKey: "Clé de signature (SHA-256)",
    secretKeyHint: "Dans le module d'administration de Redsys → Données du commerçant → « Voir la clé ». Nous la vérifions auprès de Redsys à l'enregistrement, sans rien débiter.",
    onlyEuro: "Euros uniquement · encaisse en {currency}",
    onlyEuroTip: "Redsys n'encaisse qu'en euros. Attribuez cet hébergement à un autre compte d'encaissement.",
    msg: {
      merchantCode: "Le numéro de commerçant ne contient que des chiffres (généralement neuf).",
      terminal: "Le terminal est un nombre de un à trois chiffres (presque toujours 1).",
      secretKey: "Il manque la clé de signature Redsys.",
    },
  },
};
